"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginBtn = void 0;
var _react = _interopRequireDefault(require("react"));
var _LoginBtn = require("./LoginBtn.styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var LoginBtn = function LoginBtn(props) {
  var imgSrc = props.imgSrc,
    imgLabel = props.imgLabel,
    textLabel = props.textLabel,
    className = props.className,
    onClick = props.onClick;
  var styles = (0, _LoginBtn.useStyles)();
  var handleClick = function handleClick(event) {
    if (onClick) {
      onClick(event);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
    className: "".concat(styles['cc-Login__login-btn'], " ").concat(className),
    onClick: handleClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      className: styles['cc-Login__login-btn__image'],
      src: imgSrc,
      alt: imgLabel
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-Login__login-btn__text'],
      dangerouslySetInnerHTML: {
        __html: textLabel
      }
    })]
  });
};
exports.LoginBtn = LoginBtn;